import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const topicApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topics/`, {params: params})
  },
  detail (topicId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topics/${topicId}/`, {params: params})
  }
}

export default topicApi
